import axios from '../../axios';
import * as types from '../types';
import { setMsgInfo } from '..';
import filterError from '../common/filterError';
import API from '../api';

const baseUrl = API + '/admin/org_function_proposal/';

export const getAllOrgFunctionProposals = () => {
  return async (dispatch) => {
    dispatch({ type: types.ORG_FUNCTION_PROPOSAL_LOADING });
    try {
      const { data } = await axios.get(baseUrl);
      dispatch({ type: types.GET_ALL_ORG_FUNCTION_PROPOSAL_SUCCESS, payload: data });
      return data;
    } catch (err) {
      dispatch({ type: types.ORG_FUNCTION_PROPOSAL_FAILURE, payload: filterError(err) });
      throw err;
    }
  };
};

export const approveOrgFunctionProposal = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.put(`${baseUrl}${id}/approve/`);
      dispatch({ type: types.APPROVE_ORG_FUNCTION_PROPOSAL_SUCCESS, payload: data });
      dispatch(setMsgInfo({ success: true, msg: ['Proposal approved'] }));
      return data;
    } catch (err) {
      dispatch(setMsgInfo({ success: false, msg: filterError(err) }));
      throw err;
    }
  };
};

export const rejectOrgFunctionProposal = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.put(`${baseUrl}${id}/reject/`);
      dispatch({ type: types.REJECT_ORG_FUNCTION_PROPOSAL_SUCCESS, payload: data });
      dispatch(setMsgInfo({ success: true, msg: ['Proposal rejected'] }));
      return data;
    } catch (err) {
      dispatch(setMsgInfo({ success: false, msg: filterError(err) }));
      throw err;
    }
  };
};

export const bulkDeleteOrgFunctionProposals = (ids) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.delete(baseUrl + 'bulk_delete/', { data: { ids } });
      dispatch({ type: types.BULK_DELETE_ORG_FUNCTION_PROPOSAL, payload: ids });
      return data;
    } catch (err) {
      dispatch(setMsgInfo({ success: false, msg: filterError(err) }));
      throw err;
    }
  };
};